document.addEventListener('DOMContentLoaded', function() {
  const submitButtons = document.querySelectorAll('[data-discontinued-submit]');

  // Pressing Enter in the email field should behave like clicking the button
  document.querySelectorAll('[data-discontinued-form]').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      this.querySelector('[data-discontinued-submit]')?.click();
    });
  });

  submitButtons.forEach(button => {
    button.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();

      const form = this.closest('[data-discontinued-form]');
      const emailInput = document.getElementById('discontinued-email-input');

      // Button is type="button", so trigger native email validation manually
      if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      const email = emailInput.value.trim();
      const listId = form.getAttribute('data-list-id') || 'LRmVPv';

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            },
            custom_source: 'discontinued_launch_crew'
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      };

      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=LFDYCZ', {
          method: 'POST',
          headers: {
            'accept': 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            'revision': '2025-01-15'
          },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          // Success! Replace the form with a confirmation message
          const container = document.getElementById('discontinued-form');
          container.innerHTML = '<div class="text-center p-4"><p class="text-sm">Thanks! You\'re on the Launch Crew list. Keep an eye out for product drops.</p></div>';
        } else {
          throw new Error('Subscription failed');
        }
      } catch (error) {
        console.error('Error:', error);
        const errorDiv = form.querySelector('.error-message') || document.createElement('div');
        errorDiv.className = 'error-message text-red-500 text-sm mt-2';
        errorDiv.textContent = 'Sorry, there was an error. Please try again.';
        if (!form.querySelector('.error-message')) {
          form.appendChild(errorDiv);
        }
      }
    });
  });
});
